import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Can I get life insurance if I'm self-employed with variable income?",
    a: "Yes. Carriers typically average your net income from the last two tax years (Schedule C, K-1, or 1099s). Documentation like tax returns and a simple P&L is usually enough. As an independent producer, I present your income to the carriers most likely to approve you at the best rate.",
  },
  {
    q: "How does a Buy-Sell agreement protect my business partner?",
    a: "A funded Buy-Sell agreement uses life insurance so that, on an owner's death or disability, the death benefit buys out their share at a pre-agreed value. The family receives fair value in cash, and the surviving partner keeps full control — without taking on an unintended co-owner.",
  },
  {
    q: "What are living benefits, and how do they pay out before death?",
    a: "Living benefits (accelerated death benefit riders) let you access part of your death benefit while alive if you're diagnosed with a critical, chronic, or terminal illness. You receive tax-advantaged funds for medical bills or lost income; whatever you don't use remains for your beneficiaries.",
  },
  {
    q: "How much does a policy actually cost?",
    a: "It depends on age, health, coverage amount, and policy type. Term life is the most affordable per dollar of coverage. We shop multiple A-rated carriers and show you options side by side — there's no cost or obligation to compare.",
  },
  {
    q: "Do you charge a fee for your guidance?",
    a: "No. Our guidance is free to you — carriers compensate the agency when you choose to enroll. You decide if and when to apply, through official, secure carrier portals.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-warm-white py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-4">
          <p className="eyebrow text-gold mb-4 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-gold" /> FAQ
          </p>
          <h2 className="font-heading font-extrabold tracking-tighter text-navy text-[clamp(2rem,4.5vw,3.4rem)] leading-[1]">
            Questions, answered plainly.
          </h2>
          <p className="mt-5 text-brand-slate leading-relaxed">
            Still unsure about something? Reach out — a licensed agent is happy to walk you through it.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-black/[0.1]">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-heading font-bold text-navy text-lg sm:text-xl py-6 hover:no-underline"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-brand-slate text-base leading-relaxed pb-6 pr-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
